import { useRef, useState } from "react";
import { featuredProducts } from "@/mocks/categories";

export default function FeaturedProducts() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollState = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
  };

  const scroll = (direction: "left" | "right") => {
    if (!scrollRef.current) return;
    const amount = 320;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  if (featuredProducts.length === 0) return null;

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      <div className="max-w-[1200px] mx-auto">
        {/* Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium mb-3">
              Destaques
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Produtos em Destaque
            </h2>
          </div>
          {/* Nav arrows */}
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll("left")}
              disabled={!canScrollLeft}
              className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-foreground-300 text-foreground-700 cursor-pointer hover:border-foreground-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll("right")}
              disabled={!canScrollRight}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer hover:bg-primary-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        {/* Scroll container */}
        <div
          ref={scrollRef}
          onScroll={updateScrollState}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollSnapType: "x mandatory" }}
        >
          {featuredProducts.map((product, idx) => (
            <a
              key={product.id}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[260px] sm:w-[280px] cursor-pointer group"
              style={{ scrollSnapAlign: "start" }}
            >
              <div className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-shadow hover:shadow-md relative">
                {/* Tag */}
                {idx === 0 && (
                  <div className="absolute top-3 left-3 z-10">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      Novo
                    </span>
                  </div>
                )}
                {/* Image */}
                <div className="aspect-square bg-background-100 relative">
                  <img
                    src={product.image}
                    alt={`CSSBuy Spreadsheet - ${product.name}`}
                    title={`CSSBuy Spreadsheet ${product.name}`}
                    className="w-full h-full object-cover p-2"
                  />
                </div>
                {/* Info */}
                <div className="p-4 text-center">
                  <p className="text-foreground-400 text-xs mb-1">{product.category}</p>
                  <h4 className="font-heading text-foreground-950 font-semibold text-sm mb-2">
                    {product.name}
                  </h4>
                  <p className="text-accent-600 font-bold text-lg">{product.price}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}